import React from 'react';
import { db, auth } from './Firebase/firebase';
import { useState } from 'react';
import { useEffect } from 'react';

import loading_gif from './assets/loading.gif';
import logo from './assets/usku_logo.png';
import './admin.css';

function OrderDetails (props) {

    const { id } = props.match.params;
    const [loading, setLoading] = useState(true);
    const [user, setUser] = useState(null);
    const [order, setOrder] = useState({});

    useEffect(() => {
        const authListener = auth.onAuthStateChanged(
            (authUser) => {
                if(authUser) {
                    setUser(authUser);
                    getData();
                }      
            }
          );
          return authListener;
    }, []);

    async function getData() {
        try {
            await db.collection('swift').doc(id)
                .get()
                .then((doc) => {
                    if (doc.exists) {
                        setOrder(doc.data());
                        setLoading(false);
                    } else {
                        console.log('Record not found')
                    }
                })
        } catch (e) {
            console.log('There is an error when fetching data');
        }
    }

    if (user == null) {
        return (
            <div style={{textAlign: "center"}}>
                <img className="usku-logo" src={logo} alt="Usku" />
                <h3 style={{textAlign: "center"}}>You are not logged in as an admin</h3>
                <p style={{textAlign: "center"}}>Please log in <a href="/admin"> here</a></p>
            </div>
        )
    } if (user) {
        if (loading) {
            return(<img src={loading_gif}/>)
        } else if (!loading) {
            return (
                <div style={{ margin: "20px", display: "block" }}>
                    <a href="/admin" className="btn">Back</a>
                    <h4>Order Details</h4>
                    <p style={{ display: "block", "width": "100vw", textAlign: "left" }}>Order Pin: { order.order_pin }</p>
                    <p style={{ display: "block", "width": "100vw", textAlign: "left" }}>Created at: { order.ts.seconds }</p>
                    <p style={{ display: "block", "width": "100vw", textAlign: "left" }}>Name: { order.metadata.name }</p>
                    <p style={{ display: "block", "width": "100vw", textAlign: "left" }}>Phone: { order.metadata.phone }</p>
                    <p style={{ display: "block", "width": "100vw", textAlign: "left" }}>Delivery Date: { order.metadata.deliveryDate }</p>
                    <p style={{ display: "block", "width": "100vw", textAlign: "left" }}>Delivery Time: { order.metadata.deliveryTime }</p>
                    <p style={{ display: "block", "width": "100vw", textAlign: "left" }}>Delivery Class: { order.metadata.deliveryClass }</p>
                    <p style={{ display: "block", "width": "100vw", textAlign: "left" }}>Pickup Name: { order.metadata.pickupName }</p>
                    <p style={{ display: "block", "width": "100vw", textAlign: "left" }}>Pickup Address: { order.metadata.pickupAddress }</p>
                    <p style={{ display: "block", "width": "100vw", textAlign: "left" }}>Delivery Address: { order.metadata.deliveryAddress }</p>
                    <p style={{ display: "block", "width": "100vw", textAlign: "left" }}>Pickup Instructions: { order.metadata.pickupInstruction }</p>
                    <p style={{ display: "block", "width": "100vw", textAlign: "left" }}>Number of Items: { order.metadata.numberOfItems }</p>
                    <p style={{ display: "block", "width": "100vw", textAlign: "left" }}>Item: { order.metadata.item }</p>
                    <p style={{ display: "block", "width": "100vw", textAlign: "left" }}>Prepurchase: { order.metadata.prePurchase }</p>
                    <p style={{ display: "block", "width": "100vw", textAlign: "left" }}>Cost: { order.metadata.cost }</p>
                    <p style={{ display: "block", "width": "100vw", textAlign: "left" }}>Details: { order.metadata.details }</p>

                    <h4>Payer Information</h4>
                    <p style={{ display: "block", "width": "100vw", textAlign: "left" }}>Name: { order.metadata.payerName }</p>
                    <p style={{ display: "block", "width": "100vw", textAlign: "left" }}>Phone: { order.metadata.payerPhone }</p>
                    <p style={{ display: "block", "width": "100vw", textAlign: "left" }}>Email Address: { order.metadata.email }</p>


                </div>
            )
        }
    }
}

export default OrderDetails;